<template>
<div id="main-search-child">
    <header style="position: absolute;">検索設定<div class="h-right"><a @click="isSearch = false; $emit('close', formData); setFooter(true)"><img src="~@/assets/images/icon05.svg"></a></div>
    </header>
    <div id="wrap" v-if="!isSearch">
        <div id="fbt">
            <div class="fbt">
                <a @click="reset">
                    <div class="fbt01"><img src="~@/assets/images/fbt-iocn01.svg" /></div>
                </a>
                <a @click="search">
                    <div class="fbt02"><img src="~@/assets/images/fbt-iocn02.svg" /></div>
                </a>
            </div>
        </div>
        <form>
            <div class="search-form">
                <table>
                    <tr>
                        <th>募集日</th>
                        <td style="padding: 0 4px; font-size: 12px" @click="isShowDateDialog = true">
                            {{ formData.free_at || "選択してください"}}
                        </td>
                    </tr>
                </table>
            </div>

            <div class="search-form-title">基本プロフィール</div>
            <div class="search-form">
                <table>
                    <tr>
                        <th>年齢</th>
                        <td>
                            <select style="text-align: center" v-model="formData.min_age" name="min_age" class="s-form01" @change="$emit('setData',formData); checkAge()">
                                <option :value="NO_DATA" disabled>選択してください</option>
                                <option value="">こだわらない</option>
                                <option :value="18 + index" v-for="(item, index) in 53" :key="index">{{ 18 + index }}歳</option>
                            </select>
                            ～
                            <select style="text-align: center"  v-model="formData.max_age" name="max_age" class="s-form01" @change="$emit('setData',formData); checkAge()">
                                <option :value="NO_DATA" disabled>選択してください</option>
                                <option value="">こだわらない</option>
                                <option :value="18 + index" v-for="(item, index) in 53" :key="index">{{ 18 + index }}歳</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th>身長</th>
                        <td>
                            <select style="text-align: center" v-model="formData.min_height" name="min_height" class="s-form01" @change="$emit('setData',formData); checkHeight()">
                                <option :value="NO_DATA" disabled>選択してください</option>
                                <option value="">こだわらない</option>
                                <option :value="140 + index" v-for="(item, index) in 61" :key="index">{{140 + index}}cm</option>
                            </select>
                            ～
                            <select style="text-align: center" v-model="formData.max_height" name="max_height" class="s-form01" @change="$emit('setData',formData); checkHeight()">
                                <option :value="NO_DATA" disabled>選択してください</option>
                                <option value="">こだわらない</option>
                                <option :value="140 + index" v-for="(item, index) in 61" :key="index">{{140 + index}}cm</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th>体型</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.style, '体型', 'style')">
                                <span v-if="strSelect.style">{{strSelect.style}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>居住地</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.living_area, '居住地', 'living_area')">
                                <span v-if="strSelect.living_area">{{strSelect.living_area}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="search-form-title">詳細プロフィール</div>
            <div class="search-form">
                <table>
                    <tr>
                        <th>出身地</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.birth_place, '出身地', 'birth_place')">
                                <span v-if="strSelect.birth_place">{{strSelect.birth_place}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>同居人</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.roommate, '同居人', 'roommate')">
                                <span v-if="strSelect.roommate">{{strSelect.roommate}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>子供の有無</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.child, '子供の有無', 'child')">
                                <span v-if="strSelect.child">{{strSelect.child}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>学歴</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.education, '学歴', 'education')">
                                <span v-if="strSelect.education">{{strSelect.education}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>職業</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.job, '職業', 'job')">
                                <span v-if="strSelect.job">{{strSelect.job}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>年収</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.income, '年収', 'income')">
                                <span v-if="strSelect.income">{{strSelect.income}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>休日</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.holidays, '休日', 'holidays')">
                                <span v-if="strSelect.holidays">{{strSelect.holidays}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>お酒</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.drinking, 'お酒', 'drinking')">
                                <span v-if="strSelect.drinking">{{strSelect.drinking}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>タバコ</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.smoking, 'タバコ', 'smoking')">
                                <span v-if="strSelect.smoking">{{strSelect.smoking}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>好きな事・趣味</th>
                        <td>
                            <input @click="setRadioOption(1, 'hobby')" v-model="formData.hobby" type="radio" name="hobby" id="on02" :value="1" @change="$emit('setData',formData)" />
                            <label for="on02" class="switch-on">記載有</label>
                            <input @click="setRadioOption(0, 'hobby')" v-model="formData.hobby" type="radio" name="hobby" id="off02" :value="0" @change="$emit('setData',formData)" />
                            <label for="off02" class="switch-off">記載無</label>
                        </td>
                    </tr>
                    <tr>
                        <th>よく行く場所</th>
                        <td>
                            <input @click="setRadioOption(1, 'favorite_pace')" v-model="formData.favorite_pace" type="radio" name="favorite_pace" id="on03" :value="1" @change="$emit('setData',formData)" />
                            <label for="on03" class="switch-on">記載有</label>
                            <input @click="setRadioOption(0, 'favorite_pace')" v-model="formData.favorite_pace" type="radio" name="favorite_pace" id="off03" :value="0" @change="$emit('setData',formData)" />
                            <label for="off03" class="switch-off">記載無</label>
                        </td>
                    </tr>
                    <tr>
                        <th>初デートで行きたい場所</th>
                        <td>
                            <input @click="setRadioOption(1, 'first_place')" v-model="formData.first_place" type="radio" name="first_place" id="on04" :value="1" @change="$emit('setData',formData)" />
                            <label for="on04" class="switch-on">記載有</label>
                            <input @click="setRadioOption(0, 'first_place')" v-model="formData.first_place" type="radio" name="first_place" id="off04" :value="0" @change="$emit('setData',formData)" />
                            <label for="off04" class="switch-off">記載無</label>
                        </td>
                    </tr>
                    <tr>
                        <th>出会うまでの希望</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.meeting_condition, 'タバコ', 'meeting_condition')">
                                <span v-if="strSelect.meeting_condition">{{strSelect.meeting_condition}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>会ったときの希望</th>
                        <td>
                            <p @click="openSelect(metadata.user_profile_list.purpose, 'タバコ', 'purpose')">
                                <span v-if="strSelect.purpose">{{strSelect.purpose}}</span>
                                <span v-else class="holder">選択してください</span>
                            </p>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="search-form-title">その他</div>
            <div class="search-form">
                <table>
                    <tr>
                        <th>人気会員</th>
                        <td>
                            <select v-model="formData.popular" class="s-form01" @change="$emit('setData',formData)">
                                <option :value="NO_DATA" disabled>選択してください</option>
                                <option value="">こだわらない</option>
                                <option value="1">人気ON</option>
                                <option value="0">人気OFF</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th>通話</th>
                        <td>
                            <select v-model="formData.enabled_call" class="s-form01" @change="$emit('setData',formData)">
                                <option :value="NO_DATA" disabled>選択してください</option>
                                <option value="">こだわらない</option>
                                <option value="1">通話ON</option>
                                <option value="0">通話OFF</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th>オンライン</th>
                        <td>
                            <select v-model="formData.is_online" class="s-form01" @change="$emit('setData',formData)">
                                <option :value="NO_DATA" disabled>選択してください</option>
                                <option value="">こだわらない</option>
                                <option value="1">オンライン</option>
                                <option value="0">オフライン</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th></th>
                        <td></td>
                    </tr>
                    <tr>
                        <th></th>
                        <td></td>
                    </tr>
                    <tr>
                        <th></th>
                        <td></td>
                    </tr>
                </table>
            </div>
        </form>
        <div style="height: 100px"></div>
    </div>
    <div id="wrap2" v-else style="height: 100vh; overflow: auto">
        <a @click="redirectDetail(item)" v-for="(item, i) in timelines" :key="i">
            <div class="list">
                <div class="clearfix">
                    <div class="list-img">
                        <div class="list-image-name"><img v-if="item.avatar_url" :src="getImageUrl(item.avatar_url)" /></div>
                    </div>
                    <div class="list-inf">
                        <table>
                            <tr>
                                <td>
                                    <p>
                                        <span><span class="red b" v-if="item.is_new">NEW&nbsp;</span> {{ item.posted_at }}&nbsp;</span>
                                        <span class="list-name">{{ item.displayname }} {{ item.age }}歳
                                            {{ getLiving(item.living_area) }}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr class="list-inf">
                                <td>
                                    <p>
                                        <span v-if="parseInt(item.sex) === FEMALE">
                                            <span class="pink"><i class="fas fa-phone"></i> 通話{{
                              getCallStatus(item.enabled_call)
                            }}</span>
                                            <span class="pink2" v-if="
                              IS_WAITING_FOR_MEET === parseInt(item.is_free)
                            ">
                                                <i class="fas fa-calendar-check"></i> 本日OK
                                            </span>
                                        </span>
                                        <span v-else>
                                            <span class="pink"> {{ getFieldProfile('income', item.income) }}</span>
                                        </span>
                                    </p>
                                    <p>
                                        {{ item.content }}
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </a>
        <infinite-loading style="margin-bottom: 80px; margin-top: 20px;" @infinite="scroll" spinner="spiral" :identifier="infiniteId">
            <template v-slot:no-more></template>
            <template v-slot:no-results>
                <div id="middle">検索結果0件です</div>
            </template>
        </infinite-loading>
    </div>
</div>
<detail v-if="isShowDetail" :isShow="isShowDetail" @close="closeDetail" :timelineDetail="timelineDetail"></detail>
<div class="loading-screen" v-if="isLoading">
    <div class="loader"></div>
</div>
<div id="multi-select" class="hidden">
    <header style="top: 0; right: 0; left: 0">
        <div class="h-left">
            <a @click="closeSelect"><img src="~@/assets/images/icon02.svg" /></a>
        </div>
        <span>
            {{selectTitle}}
        </span>
    </header>
    <div id="wrap2" class="select">
        <ul>
            <li @click="removeSelectOption()"><a>こだわらない</a></li>
            <li @click="selectOption(item.value)" :class="options[typeSelect].includes(item.value) ? 'dark' : ''" v-for="(item, index) in selectList" :key="index" :value="item.value"><a @click="setValue(item.value)">{{ item.name }}</a></li>
        </ul>
    </div>
</div>

<SelectDateDialog
    v-if="isShowDateDialog"
    title="募集日"
    :date="formData.free_at"
    @save="handleSelectDate"
    @close="closeSelectDateDialog"
/>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex"
import mixin from "@/mixin"
import CONSTANTS from "@/constants"
import detail from "./detail"
import SelectDateDialog from "./selectDateDialog.vue";
export default {
    props: {
        dataSearch: Object,
    },
    components: {
        detail,
        SelectDateDialog
    },
    emits: ['close'],
    mixins: [mixin],
    data: () => ({
        formData: {
            min_age: 999,
            max_age: 999,
            min_height: 999,
            max_height: 999,
            style: 999,
            living_area: 999,
            birth_place: 999,
            roommate: 999,
            child: 999,
            education: 999,
            job: 999,
            income: 999,
            holidays: 999,
            drinking: 999,
            smoking: 999,
            hobby: null,
            favorite_pace: null,
            first_place: null,
            meeting_condition: 999,
            purpose: 999,
            popular: 999,
            enabled_call: 999,
            is_online: 999,
            free_at: null
        },
        isSearch: false,
        pageCurrent: 1,
        pageSize: 20,
        infiniteId: +new Date(),
        timelines: [],
        FEMALE: CONSTANTS.FEMALE,
        IS_WAITING_FOR_MEET: CONSTANTS.IS_WAITING_FOR_MEET,
        timelineDetail: null,
        isShowDetail: false,
        scrollHeight: null,
        isLoading: false,
        options: [],
        typeSelect: null,
        strSelect: {
            style: null,
            living_area: null,
            birth_place: null,
            roommate: null,
            child: null,
            education: null,
            job: null,
            income: null,
            assets: null,
            holidays: null,
            drinking: null,
            smoking: null,
            meeting_condition: null,
            purpose: null
        },
        NO_DATA: CONSTANTS.NO_DATA,
        selectTitle: null,
        selectList: [],
        options: {
            style: [],
            living_area: [],
            birth_place: [],
            roommate: [],
            child: [],
            education: [],
            job: [],
            income: [],
            assets: [],
            holidays: [],
            drinking: [],
            smoking: [],
            meeting_condition: [],
            purpose: []
        },
        isShowDateDialog: false
    }),
    computed: {
        ...mapGetters(["metadata", "defaultToken", "userDetail"]),
    },
    mounted() {
        if (this.dataSearch) {
            this.formData = this.dataSearch
        }
    },
    methods: {
        ...mapActions({
            setFooter: 'layout/setFooter'
        }),
        openSelect(options, title, type) {
            document.getElementById('main-search-child').style.display = 'none'
            document.getElementById('multi-select').classList.remove('hidden')
            document.getElementById('multi-select').classList.add('show')
            this.selectList = options
            this.selectTitle = title
            this.typeSelect = type
        },
        closeSelect() {
            document.getElementById('main-search-child').style.display = 'unset'
            document.getElementById('multi-select').classList.add('hidden')
            document.getElementById('multi-select').classList.remove('show')
        },
        selectOption(option) {
            if (this.options[this.typeSelect].includes(option)) {
                this.options[this.typeSelect].splice(this.options[this.typeSelect].indexOf(option), 1)
            } else {
                this.options[this.typeSelect].push(option)
            }
            
            if (!this.options[this.typeSelect][0]) {
                this.styleStr = null
                return
            }
            this.strSelect[this.typeSelect] = this.metadata.user_profile_list[this.typeSelect].filter(item => {
                return this.options[this.typeSelect].includes(item.value)
            }).map(item => {
                return item.name
            }).join(', ')
            this.formData[this.typeSelect] = this.options[this.typeSelect].join(',')
            this.$emit('setData',this.formData)
        },
        removeSelectOption() {
            this.options[this.typeSelect] = []
            this.formData[this.typeSelect] = null
            this.strSelect[this.typeSelect] = null
        },
      
        setRadioOption(val, type) {
            if (val == 1) {
                if (this.formData[type] == 1) {
                    this.formData[type] = null
                }
            }   
            if (val == 0) {
                if (this.formData[type] == 0) {
                    this.formData[type] = null
                }
            }
            this.$emit('setData',this.formData)
        },
        getDaysArray(start, end) {
            let days = [];
            for (let dt = end; dt >= new Date(start); dt.setDate(dt.getDate() - 1)) {
                days.push(new Date(dt));
            }
            days = days.map((v) => {
                return this.formatDateTime(v);
            });
            return days;
        },
        closeDetail() {
            document.getElementById('main-search-child').style.display  = 'block'
            this.isShowDetail = false
            setTimeout(() => {
                 window.scrollTo(0, this.scrollHeight);
            }, 1)
        },
        reset() {
            this.formData = {
                free_at: null,
                min_age: CONSTANTS.NO_DATA,
                max_age: CONSTANTS.NO_DATA,
                min_height: CONSTANTS.NO_DATA,
                max_height: CONSTANTS.NO_DATA,
                style: CONSTANTS.NO_DATA,
                living_area: CONSTANTS.NO_DATA,
                birth_place: CONSTANTS.NO_DATA,
                roommate: CONSTANTS.NO_DATA,
                child: CONSTANTS.NO_DATA,
                education: CONSTANTS.NO_DATA,
                job: CONSTANTS.NO_DATA,
                income: CONSTANTS.NO_DATA,
                holidays: CONSTANTS.NO_DATA,
                drinking: CONSTANTS.NO_DATA,
                smoking: CONSTANTS.NO_DATA,
                hobby: null,
                favorite_pace: null,
                first_place: null,
                meeting_condition: CONSTANTS.NO_DATA,
                purpose: CONSTANTS.NO_DATA,
                popular: CONSTANTS.NO_DATA,
                enabled_call: CONSTANTS.NO_DATA,
                is_online: CONSTANTS.NO_DATA
            }
            this.strSelect = {
                style: null,
                living_area: null,
                birth_place: null,
                roommate: null,
                child: null,
                education: null,
                job: null,
                income: null,
                assets: null,
                holidays: null,
                drinking: null,
                smoking: null,
                meeting_condition: null,
                purpose: null
            }
            this.options = {
                style: [],
                living_area: [],
                birth_place: [],
                roommate: [],
                child: [],
                education: [],
                job: [],
                income: [],
                assets: [],
                holidays: [],
                drinking: [],
                smoking: [],
                meeting_condition: [],
                purpose: []
            }
        },
        async redirectDetail(item) {
            this.scrollHeight = document.documentElement.scrollTop || document.body.scrollTop
            document.getElementById('main-search-child').style.display  = 'none'
            await this.$store.dispatch('timeline/getTimelineDetail', {
                token: this.defaultToken,
                user_id: item.user_id,
                keijiban_id: item.id
            }).then(data => {
                this.timelineDetail = data

            }).catch(err => {
                console.log(err)
            })
            this.isShowDetail = true
        },

        search() {
            this.isLoading = true
            this.isSearch = true
            this.pageCurrent = 1
            this.timelines = []
            this.infiniteId++
        },
        async scroll($state = null) {
            if (this.timelines.length > 0 && this.timelines.length < this.pageSize && $state) {
                $state.complete();
                return;
            }
            let form = Object.assign(this.formData, {
                page: this.pageCurrent,
                limit: this.pageSize,
                token: this.defaultToken,
            })

            let asArray = Object.entries(form);
            form = asArray.filter(item => {
                return item[1] !== 999 && item[1] !== null && item[1] !== ''
            })
            form = Object.fromEntries(form)
            await this.$store
                .dispatch("timeline/getTimeline", form)
                .then((data) => {
                    if (data.result.length > 0) {
                        data.result = data.result.filter(item => {
                            return item.category_id !== 0
                        })
                    }
                    if (data.result.length > 0) {
                        this.pageCurrent++;
                        this.timelines.push(...data.result)
                        this.timelines = this.timelines.sort((a, b) => {
                            if (new Date(a.created_at) > new Date(b.created_at)) return -1;
                            if (new Date(a.created_at) < new Date(b.created_at)) return 1;
                            return 0;
                        });
                        if ($state) {
                            $state.loaded();
                        }
                    } else {
                        if ($state) {
                            $state.complete();
                        }
                    }
                })
                .catch((err) => {
                    if ($state) {
                        $state.complete();
                    }
                });
            this.isLoading = false
        },
        getLiving(id) {
            if (!this.metadata.user_profile_list) return
            let living = this.metadata.user_profile_list.living_area.filter(
                (item) => {
                    return item.field_id === id;
                }
            );
            if (living[0]) {
                return living[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        getIncome(id) {
            if (!this.metadata.user_profile_list) return
            let income = this.metadata.user_profile_list.income.filter((item) => {
                return item.field_id === id;
            });
            if (income[0]) {
                return income[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        getFieldProfile(field, id) {
            if (!this.metadata) return null
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        checkAge() {
            if (this.formData.min_age !== CONSTANTS.NO_DATA && parseInt(this.formData.min_age) > parseInt(this.formData.max_age)) {
                let temp = this.formData.max_age
                this.formData.max_age = this.formData.min_age
                this.formData.min_age = temp
            }
        },
        checkHeight() {
            if (this.formData.min_height !== CONSTANTS.NO_DATA && parseInt(this.formData.min_height) > parseInt(this.formData.max_height)) {
                let temp = this.formData.max_height
                this.formData.max_height = this.formData.min_height
                this.formData.min_height = temp
            }
        },
        handleSelectDate(selectedDate) {
            this.isShowDateDialog = false
            this.formData.free_at = this.formatDateTime(selectedDate)
        },
        closeSelectDateDialog() {
            this.isShowDateDialog = false
        }
    }
}
</script>

<style scoped>
    #wrap {
        overflow: scroll;
        height: 100vh;
    }
    #multi-select {
        transition: right 0.2s
    }
    .hidden {
        position: fixed;
        right: -100%;
        width: 100%;
        overflow: hidden;
        /* opacity: 0; */
    }
    .show {
        position: fixed;
        right: 0;
        width: 100%;
        height: 100%;
        overflow: unset
        /* opacity: 1; */
    }
    @media only screen and (max-width: 457px) {
        .search-form th {
            width: 35%;
            padding: 14px 0;
            vertical-align: middle;
            line-height: 16px;
            font-size: 10.5px;
        }
    }
    .select ul li {
        color: #fff;
        border-bottom: 1px solid rgb(133, 133, 133);
        padding: 10px;
    }
    .select ul li a {
        color: rgb(0, 0, 0)
    }
    .select ul li.dark {
        background: #e7e7e7;
    }
    #multi-select {
        transition: right 0.2s
    }
    td p {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }
    td p span {
        color: #363636;
        font-size: 12px;
        font-family: Arial;
    }
    .search-form label {
        color: #363636;
        font-size: 12px;
        font-family: Arial;
    }
    .select ul {
        height: 100vh;
        overflow: scroll;
    }

    #multi-select ul li:last-child {
        margin-bottom: 200px;
    }
</style>